import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-timesheet',
  templateUrl: './main-timesheet.component.html',
  styleUrls: ['./main-timesheet.component.css']
})
export class MainTimesheetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
